import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const CalendarWrapper = styled.div`
  background: ${colors.base.alpha};
  border-radius: 8px;

  .fc-timegrid-slot {
    min-height: 35px;
    height: 35px;
  }

  .fc-timegrid-event {
    min-height: 30px;
    height: auto;
  }

  .fc-timegrid-slot-label {
    height: 35px;
    line-height: 35px;
  }

  .fc-timegrid-event-harness {
    min-height: 30px;
  }

  .fc-v-event {
    background-color: unset;
    border: unset;
  }

  .fc .fc-more-popover .fc-popover-body {
    max-height: 250px;
    overflow-y: auto;
  }
`;

const EventContent = styled.div`
  font-size: 11px;
  padding: 2px 4px;
  background-color: ${colors.shades.success2};
  color: ${colors.base.alpha};
  border:1px solid ${colors.base.gamma};
  border-radius: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const EventTime = styled.div`
  font-weight: bold;
`;

const EventTitle = styled.div`
  font-size: 10px;
`;

const EventContentError = styled.div`
  display: flex;
  justify-content: center;
  font-size: 14px;
  margin-top: 50px;
`;

const TimeZoneText = styled.div`
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 500;
  margin: 10px 0;
`;

export {
  CalendarWrapper,
  EventContent,
  EventTime,
  EventTitle,
  EventContentError,
  TimeZoneText,
};
